"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useAnimatedRating } from "./hooks";
const RatingCircle = t0 => {
  const $ = _c(19);
  const {
    roundedRating,
    bgColor,
    label,
    isVisible
  } = t0;
  const {
    displayValue,
    animatedProgress
  } = useAnimatedRating(roundedRating, isVisible);
  const animatedPercentage = animatedProgress / 5 * 100;
  const animatedRotation = animatedPercentage / 100 * 360;
  const t1 = `${bgColor}30`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="absolute inset-0 rounded-full" style={{
      border: "4px solid",
      borderColor: t1,
      transition: "border-color 0.6s ease-in-out"
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `conic-gradient(from -90deg, ${bgColor} 0deg, ${bgColor} ${animatedRotation}deg, transparent ${animatedRotation}deg)`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="absolute inset-0 rounded-full" style={{
      background: t3,
      clipPath: "circle(50% at 50% 50%)",
      WebkitClipPath: "circle(50% at 50% 50%)"
    }} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute rounded-full" style={{
      width: "calc(100% - 8px)",
      height: "calc(100% - 8px)",
      top: "4px",
      left: "4px",
      backgroundColor: "white"
    }} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== bgColor) {
    t6 = {
      color: bgColor,
      transition: "color 0.6s ease-in-out"
    };
    $[5] = bgColor;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== displayValue || $[8] !== t6) {
    t7 = <div className="absolute inset-0 flex items-center justify-center z-10"><span className="text-xl font-bold font-poppins" style={t6}>{displayValue}</span></div>;
    $[7] = displayValue;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t7) {
    t8 = <div className="relative w-14 h-14 mb-1">{t2}{t4}{t5}{t7}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== label) {
    t9 = <span className="text-xs font-medium text-gray-700 font-poppins text-center">{label}</span>;
    $[14] = label;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="flex flex-col items-center">{t8}{t9}</div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default RatingCircle;